import { TWorkflowStepDefinition } from '@commenda/types';
import {
  getJsonSchemaPropertyNames,
  toJsonSchema,
} from '@commenda/utils/json-schema';

export const getEdgeConditionSuggestions = (
  input: string,
  steps: ReadonlyArray<Pick<TWorkflowStepDefinition, 'id' | 'outputSchema'>>
): string[] => {
  if (input.length < 3) {
    return ['__context__', '__steps__'];
  }

  if (!input.startsWith('__steps__.')) return [];

  const allSegments = input.split('.');
  if (allSegments.length === 2) {
    return steps
      .filter(
        (step) =>
          step.outputSchema !== undefined &&
          step.id.includes(allSegments[1] ?? '')
      )
      .map((step) => step.id);
  }

  const stepId = allSegments[1];
  const stepOutputSchema = toJsonSchema(
    steps.find((step) => step.id === stepId)?.outputSchema
  );
  if (!stepOutputSchema) return [];

  let currentSchema = stepOutputSchema;
  const propertyPath = allSegments.slice(2);

  for (let i = 0; i < propertyPath.length - 1; i += 1) {
    const propertyName = propertyPath[i];

    if (currentSchema.type === 'object' && currentSchema.properties) {
      currentSchema = currentSchema.properties[propertyName];
    } else if (currentSchema.type === 'array' && currentSchema.items) {
      currentSchema =
        currentSchema.items.type === 'object'
          ? currentSchema.items.properties?.[propertyName]
          : undefined;
    } else {
      return [];
    }

    if (!currentSchema) return [];
  }

  const suggestions = getJsonSchemaPropertyNames(currentSchema);
  const lastSegment = propertyPath[propertyPath.length - 1] || '';
  return suggestions.filter((property) =>
    property.toLowerCase().includes(lastSegment.toLowerCase())
  );
};
